import React from 'react';
import styled from 'styled-components';

function Footer({start, end, active, ...props}) {
  return (
    <Container {...props}>
      <Start active={active}>{start}</Start>
      <End active={active}>{end}</End>
    </Container>
  );
}

const Container = styled.div`
  border-top: 0.0625rem solid #E2E4EA;
  display: flex;
  align-items: center;
`;

const Section = styled.div`
  padding: ${props => props.active ? '1.125rem 1.75rem 1rem 1.75rem' : '1.125rem 1.875rem'};
`;

const Start = styled(Section)`
  flex: 1;
  white-space: nowrap; 
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 0;
`;

const End = styled(Section)`
  padding-left: 0;
`;

export default Footer;